<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="epigraph">
<h1>Epigraph</h1>
<p><strong>“Walking with a friend in the dark is better than walking alone in the light.”</strong></p>
<p><strong>–Helen Keller</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?d6af5872